import {
  csrfTokenManager,
  getLogoutFormConfig,
  getLogoutUrl,
  useGetCsrfToken,
  useGetSession,
} from "@project/application";
import {useMemo, useRef} from "react";

export function useLogoutForm() {
  const logoutFormRef = useRef<HTMLFormElement>(null);
  const csrfInputRef = useRef<HTMLInputElement>(null);
  const {data: session} = useGetSession();
  const {data: csrf} = useGetCsrfToken(session?.authenticated === true);
  const logoutUrl = useMemo(getLogoutUrl, []);

  function submitLogout() {
    const logoutConfig = getLogoutFormConfig(
      csrf ? {parameterName: csrf.parameterName} : undefined,
      csrfTokenManager.getToken(),
    );

    if (!logoutConfig || !csrfInputRef.current) return;

    csrfInputRef.current.value = logoutConfig.token;
    csrfTokenManager.clearToken();
    logoutFormRef.current?.submit();
  }

  const logoutForm = (
    <form action={logoutUrl} hidden method="POST" ref={logoutFormRef}>
      <input name={csrf?.parameterName} ref={csrfInputRef} type="hidden" />
    </form>
  );

  return {logoutForm, submitLogout};
}
